import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const INSPECTION_EVALUATIONS_ENDPOINTS = {
  V1: createEndpoints('v1', {
    INSPECTION_EVALUATIONS: '/inspection-evaluations/',
    INSPECTION_EVALUATION_DETAIL: (id: number) => `/inspection-evaluations/${id}/`,
    ADMIN_INSPECTION_EVALUATIONS: '/admin/inspection-evaluations/',
    ADMIN_INSPECTION_EVALUATION_DETAIL: (id: number) => `/admin/inspection-evaluations/${id}/`,
  }),
} as const;
